<template>
  <div class="cards column">
    <div class="card highlight__extra box__shadow row">
      <div
        class="icon row center"
        :style="{ backgroundColor: `rgba(${features[active].color}, 0.2)` }"
      >
        <i :class="features[active].icon" :style="{ color: `rgb(${features[active].color})` }"></i>
      </div>

      <div class="content column">
        <h4 class="row">{{ t(features[active].headline) }}</h4>
        <p>{{ t(features[active].text) }}</p>
      </div>
    </div>

    <div class="slider__navigation row">
      <div class="prev row center" @click="slide('prev')">
        <i class="fa-solid fa-caret-left"></i>
      </div>

      <div class="index row">
        <div
          v-for="i in features.length"
          :key="i"
          :class="['dot', { active: i - 1 === active }]"
          @click="active = i - 1"
        ></div>
      </div>

      <div class="next row center" @click="slide('next')">
        <i class="fa-solid fa-caret-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'ColumnCards',
  props: ['features'],
  setup(props) {
    const active = ref(0)

    const slide = (direction) => {
      if (direction === 'next') {
        active.value = active.value >= props.features.length - 1 ? 0 : active.value + 1
      }

      if (direction === 'prev') {
        active.value = active.value <= 0 ? props.features.length - 1 : active.value - 1
      }
    }

    return {
      active,
      slide,
    }
  },
}
</script>

<style lang="scss" scoped>
.cards {
  align-items: center;
  justify-content: center;

  .card {
    padding: 30px;
    border-radius: 15px;
    width: calc(100% - 60px);
    max-width: 650px;
    margin: 10px auto;
    height: 200px;

    @media (max-width: 599px) {
      flex-direction: column;
      text-align: center;
      width: calc(95% - 60px);
      margin: 0 auto 25px auto;
      height: auto;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &:hover {
      transform: translateY(-5px);
    }

    .icon {
      min-width: 65px;
      max-width: 65px;
      height: 65px;
      border-radius: 15px;
      margin: 0 auto;
      font-size: 2rem;
    }

    .content {
      width: 100%;
      margin-left: 20px;

      @media (max-width: 599px) {
        margin: 20px 0 0 0;
      }

      h4 {
        margin: 0;
        height: 65px;
        align-items: center;
        font-size: 1.1rem;

        @media (max-width: 599px) {
          text-align: center;
          justify-content: center;
        }
      }

      p {
        margin: auto 0;
      }
    }
  }

  .slider__navigation {
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);
    margin: -5px auto 0 auto;

    .prev,
    .next {
      font-size: 1.5rem;
      cursor: pointer;
      border-radius: 50%;
      width: 40px;
      height: 40px;

      &:hover {
        background-color: var(--arctic-5);
      }
    }

    .dot {
      background-color: var(--arctic-2);
      border-radius: 50%;
      width: 15px;
      height: 15px;
      margin: 0 2px;
      cursor: pointer;

      &.active {
        background-color: var(--arctic);
      }
    }
  }
}
</style>
